import * as types from './actionTypes';

export const getSourceList = (payload) => ({
  type: types.GET_SOURCE_LIST,
  payload,
});

export const setSourceList = (payload) => ({
  type: types.SET_SOURCE_LIST,
  payload,
});

export const createSource = (payload) => ({
  type: types.CREATE_SOURCE,
  payload,
});

export const createSourceSuccess = (payload) => ({
  type: types.CREATE_SOURCE_SUCCESS,
  payload,
});

export const createSourceFailure = (payload) => ({
  type: types.CREATE_SOURCE_FAILURE,
  payload,
});

export const clearSourceError = () => ({
  type: types.CLEAR_SOURCE_ERROR,
});

export const getSourceDetails = (payload) => ({
  type: types.GET_SOURCE_DETAILS,
  payload,
});

export const setSourceDetails = (payload) => ({
  type: types.SET_SOURCE_DETAILS,
  payload,
});

export const updateSourceStatus = (payload) => ({
  type: types.UPDATE_SOURCE_STATUS,
  payload,
});

export const updateSourceStatusSuccess = (payload) => ({
  type: types.UPDATE_SOURCE_STATUS_SUCCESS,
  payload,
});

export const setStatusUpdateSuccess = (payload) => ({
  type: types.SET_STATUS_UPDATE_SUCCESS,
  payload,
});
